import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import './CheckoutPage.css';
import ConsiliumLogo from '../assets/images/Consilium-small.png';

const parseSessionId = (search: string): string | null => {
  const params = new URLSearchParams(search);
  const value = params.get('session_id');
  return value ? value.trim() : null;
};

const CheckoutSuccess: React.FC = () => {
  const location = useLocation();
  const sessionId = useMemo(() => parseSessionId(location.search), [location.search]);

  const handleClose = () => {
    window.close();
    setTimeout(() => {
      window.location.href = 'https://www.civitassignals.com';
    }, 200);
  };

  return (
    <main className="checkout-page">
      <section className="checkout-card success">
        <div className="checkout-banner">
          <img
            src={ConsiliumLogo}
            alt="Consilium Premium"
            className="checkout-logo"
            width={160}
            height={40}
          />
          <span className="checkout-tagline">Premium Intelligence Activated</span>
        </div>

        <header className="checkout-header">
          <h1>Thank you for upgrading!</h1>
          <p>Your payment was processed successfully.</p>
        </header>

        <div className="checkout-body">
          <p>
            To finish activating your Consilium Premium benefits in the Safescope mobile app,
            return to the app and tap the <strong>Home</strong> tab. That quick refresh unlocks
            your premium features right away.
          </p>

          <p>
            If you closed the app, simply reopen it and tap Home. Need help? Share the session
            reference below with support so we can verify your upgrade instantly.
          </p>

          {sessionId ? (
            <div className="checkout-reference">
              <span className="checkout-reference-label">Stripe session reference</span>
              <code className="checkout-reference-value">{sessionId}</code>
            </div>
          ) : null}
        </div>

        <footer className="checkout-actions">
          <button
            type="button"
            className="checkout-action-button primary"
            onClick={handleClose}
          >
            Close this window
          </button>
          <a
            className="checkout-action-button"
            href="mailto:support@civitassignals.com?subject=Checkout%20help"
          >
            Contact Support
          </a>
        </footer>
      </section>
    </main>
  );
};

export default CheckoutSuccess;

